<div class="top-bar"></div>
<div role="main">
  <router-outlet></router-outlet>
</div>